import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import cx from 'classnames'
import { useRouter } from 'next/navigation'
import { useSelector } from 'react-redux'

import Button from 'components/Button'
import ROUTES from 'config/routes.json'
import content from 'prismic-translates/common.json'
import { isLoggedInSelector } from 'store/modules/user/selectors'

import classes from './styles.module.scss'

type Props = {
  caption: string
  className?: string
  openGame: () => void
}

export default function GamePagePlayButton(props: Props) {
  const { caption, openGame } = props
  const router = useRouter()
  const isLogged = useSelector(isLoggedInSelector)
  const t = getTranslationFromJson([content])

  const onClickHandler = () => {
    if (isLogged) {
      openGame()
    } else {
      router.push(ROUTES.LOGIN)
    }
  }

  // if (process.env.PROFILE === 'prod') {
  //   return (
  //     <Button className={cx(classes.button, props?.className)} disabled>
  //       coming soon
  //     </Button>
  //   )
  // }

  return (
    <Button className={cx(classes.button, props?.className)} onClick={onClickHandler}>
      {isLogged ? `${caption}` : t('login')}
    </Button>
  )
}
